import { combineReducers } from 'redux';
import redirect from './redirectReducer';
import payment from './paymentReducer';
import auth from './product/authReducer';
import productResults from './product/resultsReducer';
import productReview from './product/reviewReducer';
import productNewForm from './product/searches/newReducer';
import productList from './product/searches/listReducer';
import productDashboard from './product/searches/dashboardReducer';
import productEmbed from './product/embedReducer';
import companySettings from './product/settingsReducer';
import fingerprinting from './product/fingerprintingReducer';
import analytics from './product/analyticsReducer';
import contentIdAssets from './product/contentId/assetsReducer';
import contentIdClaims from './product/contentId/claimsReducer';
import contentIdAllowlist from './product/contentId/allowlistReducer';
import adminAuth from './admin/authReducer';
import adminCompany from './admin/companyReducer';
import adminFileImports from './admin/fileImportsReducer';
import adminSearches from './admin/searchReducer';
import adminMonetizationRequests from './admin/monetizationRequestsReducer';
import adminPayouts from './admin/payoutsReducer';
import adminCidPayoutStatus from './admin/cidPayoutStatusReducer';
import creatorReferral from './product/creatorReferralReducer';
import adminCustomOnboarding from './admin/customOnboardingReducer';
import adminOnboardings from './admin/adminOnboardingsReducer';
import adminCidAnalytics from './admin/cidAnalyticsReducer';
import adminYtAudits from './admin/adminYtAuditsReducer';
import nagraMonitoring from './admin/nagra/nagraMonitoringReducer';
import nagraCandidates from './admin/nagra/nagraCandidatesReducer';
import cyclops from './cyclops/cyclopsReducer';
import organizations from './cyclops/organizationsReducer';
import notice from './noticeReducer';
import favicon from './faviconReducer';
import appLoader from './appLoaderReducer';
import appConfig from './appConfigReducer';
import fetchLoader from './fetchLoaderReducer';

const rootReducers = combineReducers({
  redirect,
  payment,
  auth,
  productReview,
  productResults,
  productNewForm,
  productList,
  productDashboard,
  productEmbed,
  fingerprinting,
  analytics,
  contentIdAssets,
  contentIdClaims,
  contentIdAllowlist,
  companySettings,
  adminAuth,
  adminCompany,
  adminFileImports,
  adminSearches,
  adminMonetizationRequests,
  adminPayouts,
  adminCidPayoutStatus,
  creatorReferral,
  adminCustomOnboarding,
  adminOnboardings,
  adminCidAnalytics,
  adminYtAudits,
  nagraMonitoring,
  nagraCandidates,
  cyclops,
  organizations,
  notice,
  favicon,
  appLoader,
  appConfig,
  fetchLoader,
});

export default rootReducers;
